import { useState } from 'react';
import { Currency } from '../CurrencySelection';
import { sortCurrencies } from '../utils';

export const useSearch = (currencies: Currency[]) => {
  const [searchTerm, setSearchTerm] = useState('');

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value.trim());
  };

  const filteredCurrencies = sortCurrencies(currencies).filter(
    (currency) =>
      currency.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      currency.symbol.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const searchIdle = searchTerm === '';
  const searchHasResults = filteredCurrencies.length > 0;

  return {
    searchTerm,
    filteredCurrencies,
    searchIdle,
    searchHasResults,
    setSearchTerm,
    handleSearchChange,
  };
};
